import { AppRequest } from '@/model/AppRequest';
import { CRUD } from './base/crud';

class AppRequestsService extends CRUD<AppRequest, any> {
    readonly endPoint = 'admin/app-requests';

    async cancel(id: number, refund: boolean, message: string): Promise<AppRequest> {
        const response = await this.post<{request: AppRequest}>(`${this.endPoint}/${id}/cancel`, {
            refund,
            message
        });
        return response.request;
    }
}

export const appRequestsService = new AppRequestsService();
